<script>

export let title="Step 1";
export let readOnly = false;
</script>
<style>
	.title{
		@apply p-4 mb-0 font-bold leading-tight h-full overflow-hidden  ;
		height:1fr;					
	}
	
	

</style>

<div class="border-r-xs h-full">
	<h3
		class="title" 
		contenteditable=true
		bind:innerHTML={title}>
		<strong>{title}</strong>
	</h3>
</div>
